<section class="common-lateral-panel common-lateral-panel--icam-state"
  [attr.aria-labelledby]="'box-query-state-title-' + boxQueryState.id">
  <div class="common-section-title__lp-container">
    <div class="common-section-title__lp-title-icon">
      <i aria-hidden="true" class="lf-icon-process common-icon__lg common-icon__main"></i>
      <h2 class="common-section-title__lp-label-text"
        [id]="'box-query-state-title-' + boxQueryState.id"
        afTranslate="box-query-state.query-state"></h2>
    </div>
  </div>
    <div class="common-lateral-panel__process-container">
      <ul class="sidepanel-styles__container-styles">
        @for (state of boxQueryState.states; track $index) {
          <li class="sidepanel-styles__element-container"
            [ngClass]="{'sidepanel-styles__element-container--active': state.active}"
            [attr.aria-current]="state.active ? 'step' : null">
            <hr  aria-hidden="true"  aria-hidden="true"
              [ngClass]="state.active?'sidepanel-styles__active-section-line':'sidepanel-styles__middlend-section-line'">
            @if (state.active) {
              <div class="common-tag__neutral-light">
                <span class="sr-only">{{'states-process.actual-state' | afTranslate }} </span>
                <span class="common-tag__neutral-label-text">{{boxQueryState.actualState.name}}</span>
              </div>
            }
          </li>
        }
      </ul>
    </div>
  </section>
